<template>
  <modal ref='deleteBulk'>
    <template #header>
      <h5 class="modal-title mt-0">{{ $t("checklist.delete_checklist_modal.title") }}</h5>
    </template>
    <template #body>
      <form ref="addFolderForm">
        <div class="modal-body">
          {{ $t("checklist.delete_checklist_modal.content", {count: checklistItems.length}) }}
        </div>
        <div class="modal-footer">
          <div class="btn btn-outline-primary" @click.prevent=$refs.deleteBulk.close>{{$t('checklist.delete_checklist_modal.cancel')}}</div>
          <div class="btn btn-danger" @click.prevent="deleteItems">{{$t('checklist.delete_checklist_modal.delete_all')}}</div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import modal from "../_modal"

export default {
  components: {
    modal
  },
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      willDeleteChecklist: false,
      checklistItems: []
    }
  },
  methods: {
    open(checklistItems) {
      this.checklistItems = checklistItems
      this.$refs.deleteBulk.open()
    },
    checklistItemIds() {
      return this.checklistItems.map(c => c.id)
    },
    deleteItems() {
      let ids = this.checklistItemIds()
      this.store.executeBulkOperation('delete', ids).then(() => {
        this.store.sendMetrics({name: 'bulk_delete_operation', params: this.$route.params, path: this.$route.fullPath})
        this.$refs.deleteBulk.close()
        this.$emit('success')
        this.$toastr.success(this.$t('checklist.item_removed'))
      })
    },
  },
}
</script>
